import { render, staticRenderFns } from "./messageDialog.vue?vue&type=template&id=00bf4221&scoped=true"
import script from "./messageDialog.vue?vue&type=script&lang=js"
export * from "./messageDialog.vue?vue&type=script&lang=js"
import style0 from "./messageDialog.vue?vue&type=style&index=0&id=00bf4221&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf4221",
  null
  
)

export default component.exports